import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { metadata, serializeSchema } from './site';

export function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const data = metadata(pathname);
    document.title = data.title;
    function meta(attribute: 'name' | 'property', key: string, value: string) {
      let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
      if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, key); document.head.append(element); }
      element.content = value;
    }
    meta('name', 'description', data.description);
    meta('name', 'robots', data.robots);
    for (const [key, value] of Object.entries({ title: data.title, description: data.description, url: data.url, image: data.image, type: 'website', site_name: 'Cognixis', locale: 'en_US' })) meta('property', `og:${key}`, value);
    for (const [key, value] of Object.entries({ card: 'summary_large_image', title: data.title, description: data.description, image: data.image })) meta('name', `twitter:${key}`, value);
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.append(canonical); }
    canonical.href = data.url;
    let schema = document.getElementById('site-schema');
    if (data.schema) {
      if (!schema) { schema = document.createElement('script'); schema.id = 'site-schema'; schema.setAttribute('type', 'application/ld+json'); document.head.append(schema); }
      schema.textContent = serializeSchema(data.schema);
    } else schema?.remove();
  }, [pathname]);
  return null;
}
